 // Replace this with your Google OAuth Client ID
export const GOOGLE_CLIENT_ID = '259329940389-mrh1rv0pihvmhiqk8d5bvddrcvqgpi3h.apps.googleusercontent.com';

// Google OAuth scopes
export const GOOGLE_SCOPES = [
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile'
];